// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"365":"139f1dbe13ca428c","421":"320ad533f9705660","694":"b07d180e60e58294"}[chunkId] + ".js";
};